import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableModule } from "@angular/material/table";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ILoggedInUser } from "../../../interfaces/common/loggedInUser";
import { LoggedInUserService } from "../../../services/common/logged-in-user.service";
import { DistanceService } from "../../services/distance.service";
import { DistanceModel } from "../../models/distance.model";
import { ManageDistanceModel } from "../../models/manage-distance.model";

@Component({
  selector: "app-manage-distance",
  templateUrl: "./manage-distance.component.html",  
  standalone: true,  
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule, MatPaginatorModule, ReactiveFormsModule],
})
export class ManageDistanceComponent implements OnInit {
  isLoading: boolean = false;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  distanceModel: DistanceModel
  title: string  = "";
  buttonName: string = "";
  form: FormGroup;
  information: string = "";
  confirmation: string = "Confirm that you want to remove this exchange rate entry.";
  isAdding: boolean = false;

  constructor(  
    @Inject(MAT_DIALOG_DATA) public data: { from: string, to: string, distance: number},
    public dialogRef: MatDialogRef<ManageDistanceComponent>,
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private distanceService: DistanceService
  ) {}

  ngOnInit(): void {
    if(this.data.from === "" && this.data.to === ""){
      this.isAdding = true;
    }

    if(this.isAdding ){
      this.buttonName = "Add";
      this.title = "New Distance Between Locations";
    } else {
      this.buttonName = "Update";
      this.title = "Edit Distance Between Locations";
    }
    
    this.form = this.fb.group({
      from: new FormControl(''),
      to: new FormControl(''),
      distance: new FormControl(''),
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;
        this.form.patchValue(this.data);
      }      
    });
  }  

  getformValues(): ManageDistanceModel{
    return {
      from: this.form.get('from').value,
      to: this.form.get('to').value,
      distance: this.form.get('distance').value,
      userEmail: this.user.userEmail,
      userName: this.user.userName
    };
  }

  tryDelete(){
    if(confirm("Confirm that you want to remove this distance between locations.")) {
      this.delete();
    }
  }

  delete(){
    if(!this.isAdding){
      this.distanceService.deleteDistance(this.getformValues()).subscribe({
        next: (result) => {
          if (result.isSuccess) {
            this.information = "Distance between location deleted.";
          } else {
            this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error deleting distance between location: ', err);
          this.information = 'Could not delete distance between location.';
        }
      });
    }
  }

  startAction(){
    if(!this.isAdding){      
      this.distanceService.updateDistance(this.getformValues()).subscribe({
        next: (result) => {
          if (result.isSuccess) {
            this.information = "Distance between location Updated";
          } else {
            this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error updating distance between location: ', err);
          this.information = 'Could not change distance between location.';
        }
      });

    }
    else{
      this.distanceService.addDistance(this.getformValues()).subscribe({
        next: (result) => {
          if (result.isSuccess) {
            this.information = "Distance between location added.";
          } else {
            this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error adding distance between location: ', err);
          this.information = 'Could not add distance between location.';
        }
      });
    }
  }
  
  close() {
    this.dialogRef.close();
  }
}
